import { ListaTalhoesComponent } from './modules/appviews/my-fields/lista-talhoes/lista-talhoes.component';
import { Routes } from '@angular/router';
import { remoteSupportLeaveGuard } from 'app/core/guards/remote-support-leave.guard';
import { UserPermissions, UserResources } from 'app/shared/models/role';
import { AuthGuard } from './core/guards/auth-guard.service';
import { NewLoginPageComponent } from './modules/appviews/login/login-page.component';
import { DashboardComponent } from './modules/appviews/dashboard/dashboard.component';
import { PoliticaPrivacidadeComponent } from './modules/appviews/politica-privacidade/politica-privacidade.component';
import { ResetPasswordComponent } from './modules/appviews/password/reset.component';
import { TermosUsoComponent } from './modules/appviews/termos-uso/termos-uso.component';
import { ErroServidorComponent } from './modules/error/erro-servidor/erro-servidor.component';
import { ManutencaoPageComponent } from './modules/error/manutencao-page/manutencao-page.component';
import { NaoEncontradaComponent } from './modules/error/nao-encontrada/nao-encontrada.component';
import { FleetMonitoringComponent } from './modules/gestao-operacao/fleet-monitoring/fleet-monitoring.component';
import { GestaoArquivoComponent } from './modules/gestao-operacao/gestao-arquivo/gestao-arquivo.component';
import { MapaTempoComponent } from './modules/gestao-operacao/mapa-tempo/mapa-tempo.component';
import { PrevisaoTempoComponent } from './modules/gestao-operacao/previsao-tempo/previsao-tempo.component';
import { ResultadoNavegacaoComponent } from './modules/gestao-operacao/resultado-navegacao/resultado-navegacao.component';
import { BasicLayoutComponent } from './shared/components/layouts/basicLayout.component';
import { BlankLayoutComponent } from './shared/components/layouts/blankLayout.component';
import { ResumosComponent } from './modules/gestao-operacao/resumos/resumos.component';
import { MeusEquipamentosComponent } from './modules/appviews/administrativo/meus-equipamentos/meus-equipamentos.component';
import { NovaFuncionalidadePageComponent } from './modules/error/nova-funcionalidade-page/nova-funcionalidade-page.component';
import { EditarTalhoesComponent } from './modules/appviews/my-fields/editar-talhoes/editar-talhoes.component';
import { CriaTalhoesComponent } from './modules/appviews/my-fields/cria-talhoes/cria-talhoes.component';
import { ListagemTarefaTalhaoComponent } from './modules/appviews/my-fields/gerenciamento-de-talhoes/listagem-tarefa-talhao/listagem-tarefa-talhao.component';
import { DetalhesDaTarefasTalhoesComponent } from './modules/appviews/my-fields/gerenciamento-de-talhoes/detalhes-da-tarefa-talhoes/detalhes-da-tarefa-talhoes.component';
import { MyProfileComponent } from './modules/management/my-profile/my-profile.component';
import { CriarEditarTarefasTalhaoComponent } from './modules/appviews/my-fields/gerenciamento-de-talhoes/criarEditar-tarefa-talhao/criarEditar-tarefa-talhao.component';
import { RedirectAndShowToastRGuard } from './core/guards/redirect-and-show-toastr-guard.service';
import { RealtimeDeviceMonitoringComponent } from './modules/gestao-operacao/fleet-monitoring/realtime-device-monitoring/realtime-device-monitoring.component';
import { VisualizarTalhoesComponent } from './modules/appviews/my-fields/visualizar-talhoes/visualizar-talhoes.component';
import { DeleteAccountComponent } from './modules/management/my-profile/delete-account/delete-account.component';
import { SprayRateComponent } from './modules/gestao-operacao/spray-rate/spray-rate.component';
import { DownloadFilePageComponent } from './modules/area-trabalho/download-file-page/download-file-page.component';
import { AgrirouterOnboardComponent } from './shared/components/agrirouter-onboard/agrirouter-onboard.component';
import { AgrodriveComponent } from './modules/gestao-operacao/agrodrive/agrodrive.component';
import { DataExchangeComponent } from './modules/appviews/data-exchange/data-exchange.component';
import { JohnDeereIntegrationComponent } from './modules/appviews/john-deere-integration/john-deere-integration.component';
import { CampaignsListComponent } from './modules/area-trabalho/download-file-page/campaigns/campaigns-list/campaigns-list.component';
import { UtilitiesComponent } from './modules/utilities/utilities.component';
import { PwmSprayCalculatorComponent } from './modules/utilities/pwm-spray-calculator/pwm-spray-calculator.component';
import { mobileAppStoreRedirectGuard } from './core/guards/mobile-app-store-redirect.guard';
import { PassToPassCalculatorComponent } from './modules/utilities/pass-to-pass-calculator/pass-to-pass-calculator.component';
import { RemoteSupportComponent } from './modules/area-trabalho/remote-support/remote-support.component';

export const ROUTES: Routes = [
  {
    path: '',
    component: BasicLayoutComponent,
    pathMatch: 'full',
    data: {
      breadcrumb: 'breadcrumb.title-dashboard',
    },
    children: [
      { path: '', component: DashboardComponent },
      {
        path: 'monitoramento-frota',
        component: FleetMonitoringComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-dashboard',
          authorization: {
            resource: UserResources.FLEET_MONITORING,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
    ],
    canActivate: [AuthGuard],
  },

  {
    path: 'login',
    component: BlankLayoutComponent,
    children: [{ path: '', component: NewLoginPageComponent }],
  },
  {
    path: 'menu',
    canActivate: [AuthGuard],
    component: BasicLayoutComponent,
    children: [{ path: '', component: DashboardComponent }],
  },
  {
    path: 'register',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'termos-uso',
    component: BlankLayoutComponent,
    children: [{ path: '', component: TermosUsoComponent }],
  },
  {
    path: 'politica-privacidade',
    component: BlankLayoutComponent,
    children: [{ path: '', component: PoliticaPrivacidadeComponent }],
  },
  {
    path: 'forgot',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'reset',
    component: BlankLayoutComponent,
    children: [{ path: '', component: ResetPasswordComponent }],
  },
  { path: 'manage', redirectTo: '', pathMatch: 'full' },
  {
    path: 'manage',
    component: BasicLayoutComponent,
    children: [
      {
        path: 'my-profile',
        component: MyProfileComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'profile.title',
          authorization: {
            resource: UserResources.USER_PROFILE,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'delete-account',
        component: DeleteAccountComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'delete-account-page.title',
          authorization: {
            resource: UserResources.USER_PROFILE,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'agrirouter',
        redirectTo: 'connections/agrirouter',
        pathMatch: 'full',
      },
      {
        path: 'connections',
        component: DataExchangeComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'dashboard.title-data-transfer',
          authorization: {
            resource: UserResources.USER_PROFILE,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'connections/agrirouter',
        component: AgrirouterOnboardComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'dashboard.title-data-transfer',
          authorization: {
            resource: UserResources.USER_PROFILE,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'connections/john-deere',
        component: JohnDeereIntegrationComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'dashboard.title-data-transfer',
          authorization: {
            resource: UserResources.USER_PROFILE,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
    ],
  },
  {
    path: 'user',
    component: BasicLayoutComponent,
    children: [],
  },
  {
    path: 'agrodrive',
    component: BasicLayoutComponent,
    children: [{ path: '', component: AgrodriveComponent }],
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'breadcrumb.title-agrodrive',
      authorization: {
        resource: UserResources.FIELD_ADMINISTRATION,
        permission: UserPermissions.NAVIGATE,
      },
    },
  },
  {
    path: 'suporte-tecnico',
    component: BasicLayoutComponent,
    children: [
      { path: '', component: DownloadFilePageComponent },
      {
        path: 'campanhas',
        component: CampaignsListComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-support-campaigns',
          authorization: {
            resource: UserResources.USER_ADMINISTRATION,
            permission: UserPermissions.CREATE,
          },
        },
      },
      {
        // Only members of a remote support group (the token's `remoteSupport` claim) open the page;
        // the API checks the groups again on every connect.
        path: 'acesso-remoto',
        component: RemoteSupportComponent,
        canActivate: [AuthGuard],
        canDeactivate: [remoteSupportLeaveGuard],
        data: {
          breadcrumb: 'breadcrumb.title-remote-support',
          requiresRemoteSupport: true,
        },
      },
    ],
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'breadcrumb.title-support',
      authorization: {
        resource: UserResources.CUSTOMER_SUPPORT,
        permission: UserPermissions.NAVIGATE,
      },
    },
  },
  {
    path: 'gestao-operacao',
    redirectTo: 'monitoramento-frota',
    pathMatch: 'full',
    data: {
      breadcrumb: 'breadcrumb.title-operation-management',
      authorization: {
        resource: UserResources.FLEET_MONITORING,
        permission: UserPermissions.NAVIGATE,
      },
    },
  },
  {
    path: 'administrativo',
    component: BasicLayoutComponent,
    children: [
      {
        path: 'meus-equipamentos',
        component: MeusEquipamentosComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-jobs',
          authorization: {
            resource: UserResources.FIELD_ADMINISTRATION,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
    ],
  },
  {
    path: 'gestao-operacao',
    component: BasicLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'monitoramento-frota',
        component: FleetMonitoringComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-monitoring-fleet',
          authorization: {
            resource: UserResources.FIELD_ADMINISTRATION,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'monitoramento-frota/device/:id/:type',
        component: RealtimeDeviceMonitoringComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-monitoring-fleet',
          authorization: {
            resource: UserResources.FIELD_ADMINISTRATION,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'gestao-arquivo',
        component: GestaoArquivoComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-task-report',
          authorization: {
            resource: UserResources.NAVIGATION_RESULT,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'previsao-tempo',
        component: PrevisaoTempoComponent,
        data: {
          breadcrumb: 'breadcrumb.title-weather',
          authorization: {
            resource: UserResources.WEATHER_FORECAST,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'resultado-navegacao',
        component: ResultadoNavegacaoComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-task-result',
          authorization: {
            resource: UserResources.NAVIGATION_RESULT,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'mapa-tempo',
        component: MapaTempoComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-weather-map',
          authorization: {
            resource: UserResources.WEATHER_FORECAST,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },

      {
        path: 'resumos',
        component: ResumosComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-resume',
          authorization: {
            resource: UserResources.NAVIGATION_RESULT,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
      {
        path: 'spray-rate',
        component: SprayRateComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Spray Rate Report',
          authorization: {
            resource: UserResources.NAVIGATION_RESULT,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
    ],
  },
  {
    path: 'field-notebook',
    component: BasicLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'field-notebook.title',
      requiresFieldNotebook: true,
      authorization: {
        resource: UserResources.FIELD_ADMINISTRATION,
        permission: UserPermissions.NAVIGATE,
      },
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/field-notebook/field-notebook.component').then(
            (module) => module.FieldNotebookComponent,
          ),
      },
    ],
  },
  {
    path: 'my-fields',
    component: BasicLayoutComponent,
    children: [
      {
        path: '',
        component: ListaTalhoesComponent,
        data: { breadcrumb: 'breadcrumb.title-fields' },
      },
      {
        path: 'edit/:fieldId',
        component: EditarTalhoesComponent,
        data: { breadcrumb: 'breadcrumb.title-fields-edit' },
      },
      {
        path: 'criar-talhao',
        component: CriaTalhoesComponent,
        data: { breadcrumb: 'breadcrumb.title-fields-add' },
      },
      {
        path: 'ver-talhao/:fieldId',
        component: VisualizarTalhoesComponent,
        data: { breadcrumb: 'breadcrumb.title-fields-eye' },
      },
      {
        path: 'gerenciamento-de-talhoes',
        component: BlankLayoutComponent,
        children: [
          {
            path: 'listagem-tarefa-talhao/:fieldId',
            component: ListagemTarefaTalhaoComponent,
            data: { breadcrumb: 'breadcrumb.title-fields-taks-list' },
          },
          {
            path: 'detalhes-da-tarefa-talhao/:operationFieldId',
            component: DetalhesDaTarefasTalhoesComponent,
            data: { breadcrumb: 'breadcrumb.title-fields-taks-detail' },
          },
          {
            path: 'criar-operacoes',
            canActivate: [RedirectAndShowToastRGuard],
            data: {
              toastrMesage: 'global.validate.operation-required-text',
              breadcrumb: 'breadcrumb.title-operation-create',
            },
            component: ListaTalhoesComponent,
          },
          {
            path: 'criar-tarefa-talhao/:fieldId',
            component: CriarEditarTarefasTalhaoComponent,
            data: { breadcrumb: 'breadcrumb.title-fields-taks-create' },
          },
          {
            path: 'editar-operacoes',
            canActivate: [RedirectAndShowToastRGuard],
            data: {
              toastrMesage: 'global.validate.operation-required-text',
            },
            component: ListaTalhoesComponent,
          },
          {
            path: 'editar-operacoes/:operationId',
            component: CriarEditarTarefasTalhaoComponent,
            data: { breadcrumb: 'breadcrumb.title-operation-edit' },
          },
        ],
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-fields-management',
          authorization: {
            resource: UserResources.DEVICE_ADMINISTRATION,
            permission: UserPermissions.NAVIGATE,
          },
        },
      },
    ],
    canActivate: [AuthGuard],
    data: {
      authorization: {
        resource: UserResources.FIELD_ADMINISTRATION,
        permission: UserPermissions.NAVIGATE,
      },
    },
  },
  {
    path: 'nova-funcionalidade',
    component: BlankLayoutComponent,
    children: [{ path: '', component: NovaFuncionalidadePageComponent }],
  },
  {
    path: 'acesso-negado',
    component: BlankLayoutComponent,
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'erro-servidor',
    component: BlankLayoutComponent,
    children: [{ path: '', component: ErroServidorComponent }],
  },
  {
    path: 'nao-encontrada',
    component: BlankLayoutComponent,
    children: [{ path: '', component: NaoEncontradaComponent }],
  },
  {
    path: 'manutencao',
    component: ManutencaoPageComponent,
    children: [
      {
        path: '',
        component: ManutencaoPageComponent,
      },
    ],
  },
  // Utilities are free for every authenticated user, so there is no data.authorization (premium gating) here
  {
    path: 'utilities',
    component: BasicLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'breadcrumb.title-utilities',
    },
    children: [
      { path: '', component: UtilitiesComponent },
      {
        path: 'pwm-spray-calculator',
        component: PwmSprayCalculatorComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-pwm-calculator',
        },
      },
      {
        path: 'pass-to-pass-calculator',
        component: PassToPassCalculatorComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'breadcrumb.title-pass-to-pass-calculator',
        },
      },
    ],
  },
  // Target of printed QR codes: phones and tablets go to the app store, everyone else to the web app
  {
    path: 'app',
    canActivate: [mobileAppStoreRedirectGuard],
    children: [],
  },
  {
    path: '**',
    component: NaoEncontradaComponent,
    children: [
      {
        path: 'nao-encontrada',
        component: NaoEncontradaComponent,
      },
    ],
  },
];
